import { useQuery } from "@tanstack/react-query";
import { salesApi, SalesFilters } from "./sales.api";
import { SALES_KEYS } from "./sales.keys";

export const useGetSalesAnalytics = (filters?: SalesFilters) => {
  return useQuery({
    queryKey: SALES_KEYS.GET_SALES_ANALYTICS(filters),
    queryFn: () => salesApi.getSalesAnalytics(filters),
  });
};

export const useGetSalesReports = (filters?: SalesFilters) => {
  return useQuery({
    queryKey: SALES_KEYS.GET_SALES_REPORTS(filters),
    queryFn: () => salesApi.getSalesReports(filters),
  });
};

export const useGetRevenueByService = (filters?: SalesFilters) => {
  return useQuery({
    queryKey: SALES_KEYS.GET_REVENUE_BY_SERVICE(filters),
    queryFn: () => salesApi.getRevenueByService(filters),
  });
};

export const useGetTopClients = (filters?: SalesFilters) => {
  return useQuery({
    queryKey: SALES_KEYS.GET_TOP_CLIENTS(filters),
    queryFn: () => salesApi.getTopClients(filters),
  });
};

export const useGetMonthlyTrends = (year: number, clientId?: string) => {
  return useQuery({
    queryKey: SALES_KEYS.GET_MONTHLY_TRENDS(year, clientId),
    queryFn: () => salesApi.getMonthlyTrends(year, clientId),
  });
}; 